import BakeasyTextField, { BakeasyTextFieldProps } from '../textfields/BakeasyTextField';
import { t } from 'i18next';

function BakeasyTextFieldSearch(props: BakeasyTextFieldProps) {
  function handleIconClick(event: React.MouseEvent<HTMLButtonElement>) {
    if (props.onIconClick) {
      props.onIconClick(event);
    }
  }
  return (
    <BakeasyTextField
      label={t('SEARCH')}
      type="text"
      name="search"
      value={props?.value}
      maxLength={30}
      onChange={props?.onChange}
      onIconClick={(event: React.MouseEvent<HTMLButtonElement>) => {
        handleIconClick(event);
      }}
      onEnterClick={(event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event?.key === 'Enter' && props?.onEnterClick) props?.onEnterClick(event);
      }}
    />
  );
}

export default BakeasyTextFieldSearch;
